import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AssistantService } from 'src/app/+assistant/assistant.service';
import { StripHtmlHelper } from 'src/app/shared/pipes/strip-html/strip-html.helper';
import { AssistantSearch } from '../../../../../../projects/client/apis/assistant/assistant.api-model';
import { ServiceTicketStore } from '../../../../../@store';
import { AssistantStore } from '../../../../../@store/assistant';
import { CommonStandaloneModule } from '../../../../common-standalone.module';
import { BannerComponent } from '../../../../components';
import { StripHtmlPipe } from '../../../../pipes/strip-html/strip-html.pipe';
import { ServiceTicketScrollService } from '../../../service-ticket-scroll.service';

@Component({
  selector: 'app-service-ticket-articles-list',
  standalone: true,
  imports: [CommonStandaloneModule, StripHtmlPipe, MatIconModule, BannerComponent],
  templateUrl: './service-ticket-articles-list.component.html',
  styleUrls: ['./service-ticket-articles-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketArticlesListComponent {
  @Output() articleSelected = new EventEmitter<void>();

  readonly stripHtmlParams = StripHtmlHelper.StripHtmlParams;

  constructor(
    public serviceTicketStore: ServiceTicketStore,
    private assistantStore: AssistantStore,
    private serviceTicketScrollService: ServiceTicketScrollService,
    private router: Router,
    private assistantService: AssistantService
  ) {}

  navigateToArticle(article: AssistantSearch): void {
    if (this.router.url.split('/').includes('assistant')) {
      this.assistantService.replaceStateWithDocumentIdAndUpdateOverlay(article.id);
    }

    this.articleSelected.emit();
    this.serviceTicketStore.openArticlesPage();
    this.assistantStore.selectDocument(article);
    this.serviceTicketScrollService.scrollTop$.next();
  }
}
